import { TAU, MIN_PERCENT_DISPLAYED, MIN_PERCENT_SELECTED_DISPLAYED, MIN_PERCENT_FOR_ZERO_DISPLAYED } from './donut-chart-constants';
import theme from './donut-chart.theme';

function percentToAngle(percent, offset = 0) {
  const proportion = percent / 100;
  const angle = proportion * TAU;
  return angle + offset;
}

export default function prepareDonutChartData(items) {
  if (!items || items.length === 0) {
    return [
      {
        color: theme.inactiveColor,
        fromAngle: 0,
        toAngle: TAU,
      },
    ];
  }

  if (items.every(item => typeof item.value === 'undefined')) {
    return items;
  }

  // NOTE: Proportion in item could be rounded by API
  const total = items.reduce((acc, item) => acc + item.value, 0);

  let totalPercentAdjustment = 0;
  let numAdjustedPercents = 0;

  const itemsAboveMinimum = items.map(item => {
    const percent = 100 * (item.value / total);
    const displayPercent = item.displayPercent;

    if(percent < 0.9 && !item.selected) {
      totalPercentAdjustment += MIN_PERCENT_FOR_ZERO_DISPLAYED - percent;
      ++numAdjustedPercents;

      return {
        ...item,
        percent: MIN_PERCENT_FOR_ZERO_DISPLAYED,
        displayPercent: null,
      }
    }

    let percentAdjust = Math.max(MIN_PERCENT_DISPLAYED - percent, 0);
    if (item.selected && percent < MIN_PERCENT_DISPLAYED) {
      percentAdjust = MIN_PERCENT_SELECTED_DISPLAYED - percent;
    }
    if (percentAdjust > 0) {
      totalPercentAdjustment += percentAdjust;
      numAdjustedPercents++;
    }
    return {
      ...item,
      percent: (item.selected && percent < MIN_PERCENT_DISPLAYED) ? MIN_PERCENT_SELECTED_DISPLAYED : Math.max(percent, MIN_PERCENT_DISPLAYED),
      displayPercent: displayPercent,
      percentAdjust,
    };
  });

  const adjustedItems = itemsAboveMinimum.map(
    (item) => {
      const remainingPercent = totalPercentAdjustment / (itemsAboveMinimum.length - numAdjustedPercents);
      if(item.percent > MIN_PERCENT_DISPLAYED) {
        return {
          ...item,
          percent: item.percent - remainingPercent
        }
      }

      return {
        ...item
      };
    }
  );

  const totalNumber = adjustedItems.reduce((acc, item) => acc += item.percent, 0);
  console.log("totalNumber", totalNumber);
  console.log('----------');
  let lastAngle = 0;
  const finalItems = adjustedItems.map(item => {
    const fromAngle = lastAngle;
    const toAngle = lastAngle + percentToAngle(item.percent);
    lastAngle = toAngle;
    return {
      ...item,
      fromAngle,
      toAngle,
      percent: item.percent,
    };
  });

  return finalItems;
}
